import React from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { totalPrice } from "../../utils";

// 🧾 Define Type for Cart Item
interface CartItem {
  id: number | string;
  title: string;
  proImg?: string;
  price: number;
  qty: number;
}

// 🧩 Props Interface
interface OrderReceivedSecProps {
  cartList: CartItem[];
}

const OrderReceivedSec: React.FC<OrderReceivedSecProps> = ({ cartList }) => {
  return (
    <section className="cart-recived-section section-padding">
      <div className="container">
        <div className="row">
          <div className="order-top text-center">
            <h2>
              Thank You For Your Shopping!{" "}
              <span>Your order has been received.</span>
            </h2>
            <Link to="/home" className="theme-btn">
              Back Home
            </Link>
          </div>

          <Grid className="cartStatus mt-40">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid className="cartTotals">
                  <h4>Order Details</h4>
                  <Table>
                    <TableBody>
                      {cartList.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>
                            {item.proImg && (
                              <img
                                src={item.proImg}
                                alt={item.title}
                                width={60}
                                height={60}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: 6,
                                  marginRight: 10,
                                }}
                              />
                            )}
                            {item.title} – ${item.price} × {item.qty}
                          </TableCell>
                          <TableCell align="right">
                            ${item.qty * item.price}
                          </TableCell>
                        </TableRow>
                      ))}

                      <TableRow className="totalProduct">
                        <TableCell>Total Items</TableCell>
                        <TableCell align="right">{cartList.length}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Subtotal</TableCell>
                        <TableCell align="right">
                          ${totalPrice(cartList)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <strong>Total Price</strong>
                        </TableCell>
                        <TableCell align="right">
                          <strong>${totalPrice(cartList)}</strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default OrderReceivedSec;
